export default __webpack_public_path__ + "static/media/java-svg.fed7426e.png";